import { isString } from 'lodash'
import { ReactNode } from 'react'

import { Box, Typography, Link } from '@mui/material'

import { MBreadcrumbs } from './@material-extend'
import { MBreadcrumbsProps } from './@material-extend/MBreadcrumbs'

interface HeaderBreadcrumbsProps extends MBreadcrumbsProps {
  action?: ReactNode
  heading?: ReactNode | string | null
  moreLink?: string | string[]
  more?: ReactNode
}

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  moreLink = '',
  sx,
  ...other
}: HeaderBreadcrumbsProps) {
  return (
    <Box sx={{ ...sx }}>
      {links.length !== 1 && <MBreadcrumbs links={links} {...other} />}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
        <Box sx={{ flexGrow: 1 }}>
          {heading &&
            (isString(heading) ? (
              <Typography mb={0} variant="h4" gutterBottom>
                {heading}
              </Typography>
            ) : (
              <Box>{heading}</Box>
            ))}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
      <Box>
        {isString(moreLink) ? (
          <Link href={moreLink} target="_blank" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  )
}
